import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { auth } from "@/lib/auth";
import { authClient } from "@/lib/auth-client";
import { Loader } from "lucide-react";
import { useState } from "react";

import { toast } from "@/components/ui/use-toast";
import { redirect } from "react-router";
import type { Route } from "./+types/forgot-password";

export const meta = () => {
  return [{ title: "Forgot Password" }];
};

export async function loader({ request }: Route.LoaderArgs) {
  const session = await auth.api.getSession({
    headers: request.headers,
  });

  if (session) {
    return redirect("/requests");
  }

  let domainUrl = process.env.DOMAIN_URL!;

  return { domainUrl };
}

export default function ForgotPassword({ loaderData }: Route.ComponentProps) {
  const { domainUrl } = loaderData;
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [email, setEmail] = useState("");

  return (
    <div className="flex min-h-full flex-1 flex-col mt-20 sm:px-6 lg:px-8">
      <Card className="mx-auto max-w-sm">
        <CardHeader>
          <CardTitle className="text-2xl">Forgot Password</CardTitle>
          <CardDescription>
            Enter your email address and we'll send you a link to reset your
            password.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Label>Email</Label>
          <Input
            type="email"
            name="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {error && <p className="text-red-500">{error}</p>}
          {success && <p className="text-green-500">{success}</p>}
          <Button
            type="submit"
            className="w-full mt-4"
            disabled={isLoading}
            onClick={async () => {
              setIsLoading(true);
              const { data, error } = await authClient.requestPasswordReset({
                email,
                redirectTo: `${domainUrl}/reset-password?email=${email}`,
              });
              if (error) {
                console.error("Error:", error);
                setError(error.message ?? "An error occurred");
              } else {
                setSuccess("Password reset email sent");
                console.log("Password reset email sent");
                setIsLoading(false);
                toast({
                  title: "Password reset email sent",
                  variant: "default",
                });
              }
            }}
          >
            {isLoading ? (
              <>
                <Loader className="mr-2 h-4 w-4 animate-spin" />
                Sending...
              </>
            ) : (
              "Send Reset Link"
            )}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
